import clsx from 'clsx';
import React from 'react';
import {
  BarLoader,
  BeatLoader,
  BounceLoader,
  CircleLoader,
  ClimbingBoxLoader,
  ClipLoader,
  ClockLoader,
  DotLoader,
  FadeLoader,
  GridLoader,
  HashLoader,
  MoonLoader,
  PacmanLoader,
  PropagateLoader,
  PulseLoader,
  PuffLoader,
  RingLoader,
  RiseLoader,
  RotateLoader,
  ScaleLoader,
  SkewLoader,
  SquareLoader,
  SyncLoader,
} from 'react-spinners';

const loaderMap = {
  BarLoader,
  BeatLoader,
  BounceLoader,
  CircleLoader,
  ClimbingBoxLoader,
  ClipLoader,
  ClockLoader,
  DotLoader,
  FadeLoader,
  GridLoader,
  HashLoader,
  MoonLoader,
  PacmanLoader,
  PropagateLoader,
  PulseLoader,
  PuffLoader,
  RingLoader,
  RiseLoader,
  RotateLoader,
  ScaleLoader,
  SkewLoader,
  SquareLoader,
  SyncLoader,
} as const;

type LoaderName = keyof typeof loaderMap;

type SpinnerProps = {
  name?: LoaderName;
  color?: string;
  size?: number;
  className?: string;
};

export default function Spinner({
  name = 'BeatLoader',
  color = '#36d7b7',
  size = 15,
  className,
}: SpinnerProps) {
  const Loader = loaderMap[name];
  return (
    <div className={clsx('flex justify-center', className)}>
      <Loader color={color} size={size} cssOverride={{ alignItems: 'center' }} />
    </div>
  );
}
